<template>
  <div class="contract-detail">
    <div class="purchase-box">
      <div class="purchase-header">
        <el-button class="purchase-back" icon="icon-ccui-return" size="mini" type="primary" @click="purchaseBack">返回
        </el-button>
        <div class="cut-line"/>
        <!-- 面包屑 -->
        <el-breadcrumb class="purchase-crumbs" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }">审批</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }">合同</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/#/zh-CN/component/breadcrumb' }">待办</el-breadcrumb-item>
          <el-breadcrumb-item>WZCG-20180920-0001 云商严选销售合同</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="detail-box">
      <div class="detail-info">
        <div class="details-contract">
          <div class="contract-content">
            <!--审批状态 icon-->
            <div class="content-el-Label">
              <div class="el-Label">
                <el-label v-if="labelTypeadopt" :type="a"/>
                <el-label v-if="labelTypeapproval" :type="b"/>
                <el-label v-if="labelTypenotpass" :type="c"/>
              </div>
            </div>
            <el-card-title :title="title"/>
            <div class="header-baseline">
              <div class="contract-title">
                <div>
                  <label>合同名称： </label>
                  云商严选销售合同
                </div>
                <div>
                  <label>合同编号： </label>
                  WZCG-20180920-0001
                </div>
                <div>
                  <label>合同类型： </label>
                  物资采购类
                </div>
                <div>
                  <label>乙方联系人： </label>
                  束方军
                </div>
                <div>
                  <label>经办部门： </label>
                  电子商务事业部
                </div>
                <div>
                  <label>乙方电子邮件： </label>
                  fangjun.shu@zkh360.com
                </div>
                <div>
                  <label>需用部门： </label>
                </div>
                <div>
                  <label>合同乙方： </label>
                  深圳市优舍居品科技有限公司
                </div>
                <div>
                  <label>合同甲方： </label>
                  中国交通信息中心有限公司
                </div>
                <div>
                  <label>乙方开户银行： </label>
                  中国建设银行上海市曹家渡支行
                </div>
                <div>
                  <label>合同丙方：</label>
                </div>
                <div>
                  <label>乙方联系地址： </label>
                  5号楼
                </div>
                <div>
                  <label>定价方式： </label>
                  固定价格
                </div>
                <div>
                  <label>签订时间： </label>
                  2018-09-20
                </div>
                <div>
                  <label>币种： </label>
                  人民币(元)
                </div>
                <div>
                  <label>计税方法： </label>
                  一般计税
                </div>
              </div>
            </div>
            <div class="contract-clause">
              <ul>合同条款
                <li v-for="(item,index) in clause" :key="index">
                  {{ index+1 }}.{{ item }}
                </li>
              </ul>
            </div>
            <!--费项组成-->
            <el-card-title :title="title1"/>
            <div class="contract-title-from">
              <el-table
                :data="tableData"
                :header-cell-style="{background:'#ffffff',color:'#4A4A4A'}"
                border
                lazy
                row-key="id"
                style="width: 100%"
              >
                <el-table-column
                  label="序号"
                  prop="id"
                  width="50"/>
                <el-table-column
                  label="费项名称"
                  prop="name"
                  width="93"/>
                <el-table-column
                  label="费项类型"
                  prop="name1"
                  width="99"
                />
                <el-table-column
                  label="税费类型"
                  prop="type"
                  width="170"
                />
                <el-table-column
                  label="税费种类"
                  prop="address"
                  width="85"
                />
                <el-table-column
                  class="contract-title-from-column"
                  label="税费种类"
                  prop="type"
                  width="255">
                  <el-table-column
                    label="含税金额"
                    prop="weekCount"
                    width="100"
                  />
                  <el-table-column
                    label="税后金额"
                    prop="weekAmount"
                    width="80"
                  />
                  <el-table-column
                    label="抵税后金额"
                    prop="monthCount"
                    width="90"
                  />
                </el-table-column>
              </el-table>
            </div>
            <!--合同附件-->
            <el-card-title :title="title2"/>
            <ul class="detail-enclosure">
              <li>序号</li>
              <li>附件名称</li>
              <li>文件类型</li>
              <li>合同编号</li>
              <li>合同版本</li>
              <li>操作</li>
            </ul>
            <ul class="detail-enclosure">
              <li>01</li>
              <li>云商严选销售合同.docx</li>
              <li>起草附件</li>
              <li>201901281453</li>
              <li>V 1.0</li>
              <li style="color: #5576CF">下载</li>
            </ul>
            <ul class="detail-enclosure">
              <li>02</li>
              <li>云商严选销售合同.docx</li>
              <li>起草附件</li>
              <li>201901281453</li>
              <li>V 2.0</li>
              <li style="color: #5576CF">下载</li>
            </ul>
            <!--历史记录-->
            <div class="contract-detail-historicalRecord">
              <el-history-list
                :message="message"
              />
              <p>修改了币种 ，旧值为 “美元（）”，新值为 “人民币（元）”。</p>
            </div>
          </div>
        </div>
      </div>
      <!--右边审批状态-->
      <div class="detail-react">
        <div class="timeline-approval-block">
          <div class="detail-title">
            <el-card-title :title="title2"/>
          </div>
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in activities2"
              :color="activity.color"
              :icon="activity.icon"
              :key="index"
              :size="activity.size"
              :timestamp="activity.date"
              :type="activity.type">
              <div class="contentCatamp">
                <div class="timeline-approval-blockImg">
                  <i class="icon-ccui-user"/>
                </div>
                <div class="contentCatamp_contentCat">
                  <span class="contentCat">{{ activity.name }}</span>
                  <span class="contentCategory" style="margin-left: 6px">{{ activity.weekCount }}</span>
                </div>
                <div class="contentCategory_details">{{ activity.weekAmount }}</div>
              </div>
              <p>
                <span class="contentCategory">{{ activity.conclusion }}</span>
                <span :class="conclusion">{{ activity.conclusionResult }}</span>
              </p>
              <p class="opinionSize">
                <span class="contentCategory">{{ activity.opinion }}</span>
                <span class="Opinion">{{ activity.opinionstate }}</span>
              </p>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
      <!--相关信息-->
      <div class="detail-relevant">
        <div class="detail-title">
          <el-card-title :title="title4"/>
          <p>相关订单</p>
          <p>相关需求</p>
        </div>
      </div>
    </div>
    <div class="detail-bottom">
      <ul class="detail-bottom-center">
        <li>
          <el-button icon="icon-ccui-return" type="bottom">返回</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-edit" type="bottom">编辑</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-agree" type="bottom">同意</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-disagree" type="bottom">不同意</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-reject" type="bottom">驳回</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-export" type="bottom">导出</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-copy" type="bottom">复制</el-button>
        </li>
        <li>
          <el-button icon="icon-ccui-print" type="bottom">打印</el-button>
        </li>
        <div class="bottom-center-solid"/>
        <div class="bottom-center-solid-two"/>
      </ul>
    </div>
  </div>
</template>

<script>
// import { getList } from '@/api/contract-detail'

export default {
  data() {
    return {
      pageNo: 4,
      pageSize: 10,
      conclusion: '',
      a: '审批通过',
      b: '审批中',
      c: '审批不通过',
      labelTypeadopt: false,
      labelTypeapproval: false,
      labelTypenotpass: false,
      title: '基本信息',
      title1: '费项组成',
      title2: '合同附件',
      title3: '历史记录',
      title4: '相关信息',
      clause: ['甲方中途退货，应该向乙方偿付退货部分贷款%（通用产品的涨幅为1%~5%,专用产品的涨幅为15%~30%）的违约金。', '甲方自提产品未按供方通知的日期或合同日期提货的，应比照中国人民银行有关延期付款规定，按预期提货部分贷款总值计算，向乙方偿付逾期提货的违约金，并承担乙方实际支付的代为保管、保养的费用。', '甲方逾期付款的，应按照中国人民银行有关延期付款的规定向乙方偿付逾期付款的违约金', '甲方违反合同规定拒绝接货的，应当承担由此造成的损失和运输部门的罚款', '甲方如错填到货地点和接货人，或对乙方提出错误异议，应承担乙方因此所受的损失'],
      content: '制表单位/人: 中交信科/游欢欢 2019.04.01',
      tableData: [{
        id: '1',
        date: '2016-05-02',
        name1: ' 材料费',
        name: '商品费',
        type: '增值税专用发票（16%）',
        address: '清单费',
        number: '12345'
      }],
      message: [
        {
          id: 1,
          name: '王维',
          time: '2019-01-01',
          type: 1,
          desc: [
            {
              info: '我是描述信息1'
            },
            {
              info: '我是描述信息2'
            }
          ],
          isshow: false
        },
        {
          id: 2,
          name: '刘忻',
          time: '2013-01-01',
          type: 2,
          desc: [
            {
              info: '我是描述信息1'
            },
            {
              info: '我是描述信息2'
            }
          ],
          isshow: false
        }
      ],
      activities2: []
    }
  },
  created() {
    this.getList()
  },
  activated() {
  },
  methods: {
    purchaseBack() {
      this.$router.push({ path: '/approval/contract/contract-list' })
    },
    getList() {
      this.tableData = []
      const obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        isShowLoading: true,
        data: { ...this.formLabelAlign }
      }
      getList(obj).then(res => {
        const arr = res.data.data
        this.tableData = arr
        this.activities2 = res.data.monthAmount
        let timeline_icon1 = ''// eslint-disable-line no-unused-vars
        let timeline_color = ''// eslint-disable-line no-unused-vars
        if (res.data.type === 0) {
          timeline_color = '#0bbd87'
          timeline_icon1 = 'icon-ccui-check'
          this.conclusion = 'conclusion'
          this.labelTypeadopt = true
          console.log(this.labelType)
          const data = this.activities2
          for (let i = 0; i < data.length; i++) {
            data[0].opinionstate = res.data.contentCategory
          }
        }
        if (res.data.type === 1) {
          timeline_color = '#F5A623'
          timeline_icon1 = 'icon-ccui-clock'
          this.conclusion = 'conclusion'
          this.labelTypeapproval = true
          const data = this.activities2
          for (let i = 0; i < data.length; i++) {
            data[data.length - 1].conclusion = ''
            data[data.length - 1].conclusionResult = ''
            data[data.length - 1].opinion = ''
            data[data.length - 1].opinionstate = '审批中'
            data[0].opinionstate = res.data.contentCategory
          }
        }
        if (res.data.type === 2) {
          timeline_icon1 = 'icon-ccui-warn'
          timeline_color = '#D40A0A'
          this.conclusion = 'conclusion1'
          this.labelTypenotpass = true
          const data = this.activities2
          for (let i = 0; i < data.length; i++) {
            data[i].conclusionResult = '审批不通过'
          }
        }
        const data = this.activities2
        for (var i = 0; i < data.length; i++) {
          data[data.length - 1].icon = timeline_icon1
          data[data.length - 1].color = timeline_color
          data[0].opinion = '说明：'
          data[0].weekCount = '(申请人)'
          data[0].conclusion = ''
          data[0].conclusionResult = ''
          data[0].opinionstate = res.data.contentCategory
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
  * {
    list-style: none;
  }

  .main-wrapper {
    width: 100%;
  }

  .detail-info {
    width: 56%;
    height: 100%;
    float: left;
    background: #fff;
  }

  .contract-content {
    position: relative;

    .content-el-Label {
      position: absolute;
      width: 107px;
      height: 58px;
      right: 20px;
      top: 15px;
      z-index: 999;
    }
  }

  .contract-title {
    width: 100% !important;
    margin-top: 8px;
  }

  .contract-title > div {
    width: 50% !important;
  }

  .el-table_1_column_6 > cell {
    text-align: center;
  }

  .contract-title-from {
    margin-top: 20px;
  }

  .el-card-title {
    margin: 0 !important;
  }

  .detail-enclosure {
    margin-left: -39px;
  }

  .detail-enclosure > li {
    float: left;
    width: 15%;
    height: 36px;
    line-height: 36px;
    font-size: 13px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #4A4A4A;
  }

  .detail-enclosure > li:first-child {
    width: 7%;
  }

  .detail-enclosure > li:nth-of-type(2) {
    width: 30%;
  }

  .detail-react {
    width: 380px;
    float: left;
    margin-left: 15px;
    background: #fff;
  }

  .details-contract {
    width: 100%;
  }

  .timeline-approval-blockImg > i:first-child {
    font-size: 26px;
    color: #fff;
    position: absolute;
    left: 2px;
    bottom: -1px;
  }

  .detail-box {
    width: 100%;
  }

  @media screen and (min-width: 1300px) {
    .detail-info {
      width: 66%;
    }
  }

  .detail-title {
    margin: 0 24px;
  }

  .detail-relevant {
    width: 380px;
    height: 129px;
    background: #fff;
    float: left;
    margin: 15px 0 0 15px;
  }

  .detail-title > p {
    font-size: 13px;
    color: #4A4A4A;
  }

  .detail-bottom {
    width: 98%;
    height: 40px;
    background: #4C4C4C;
    float: left;
    margin-top: 20px;
    background: rgba(76, 76, 76, 0.5);

    .detail-bottom-center {
      width: 59%;
      height: 40px;
      margin: 0 auto;
      position: relative;
    }
  }

  .detail-bottom-center > li {
    float: left;
    margin-left: 5px;
    line-height: 40px;
  }

  .detail-bottom-center > li:first-child button {
    background-color: #737373 !important;
  }

  .detail-bottom-center > li:nth-of-type(2) {
    margin-left: 50px;
  }

  .detail-bottom-center > li:nth-of-type(6) {
    margin-left: 45px;
  }

  .el-button--bottom {
    border: none !important;
  }

  .bottom-center-solid {
    position: absolute;
    width: 1px;
    height: 20px;
    background: rgba(196, 196, 196, 1);
    border-radius: 1px;
    top: 10px;
    left: 140px;
  }

  .bottom-center-solid-two {
    position: absolute;
    width: 1px;
    height: 20px;
    background: rgba(196, 196, 196, 1);
    border-radius: 1px;
    top: 10px;
    left: 490px;
  }

  .purchase-box {
    margin: 0 0 10px 0 !important;
  }

  table {
    width: 100% !important;
  }
</style>
